import { formControl } from '@al00x/forms';
import { Component, inject, signal } from '@angular/core';
import { Validators } from '@angular/forms';
import { PageEditorComponent, PageEditorData, TermsConditionService } from '@core';
import { TermsAndConditionsType } from '@models';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-terms-condition',
  imports: [PageEditorComponent],
  templateUrl: './terms-condition.component.html',
  styleUrl: './terms-condition.component.css',
})
export class TermsConditionComponent {
  readonly termsConditionService = inject(TermsConditionService);
  readonly type = TermsAndConditionsType.TermsAndConditions;
  isLoadingData = signal(true);
  
  pageEditorData: PageEditorData = {
    arabic: { controller: formControl<string>(undefined, Validators.required), title: 'الشروط والأحكام' },
    english: { controller: formControl<string>(undefined, Validators.required), title: 'Terms And Condition' },
  };

  constructor() {
    this.termsConditionService
      .getTermsAndConditionForAdmin(this.type)
      .subscribe({
        next: (res) => {
          this.pageEditorData.arabic.controller.setValue(res.termsAndConditionsDTO.arabicValue);
          this.pageEditorData.english.controller.setValue(res.termsAndConditionsDTO.englishValue);
          this.isLoadingData.set(false);
        },
        error: (error) => {
          console.error('Error loading terms and conditions data:', error);
          snackbar$.error('Error loading terms and conditions data');
          this.isLoadingData.set(false);
        }
      });
  }


  updateFunction = (): Observable<string> => {
    return this.termsConditionService.updateTermsAndConditions({
      type: this.type,
      value: {
        arabic: this.pageEditorData.arabic.controller.value,
        english: this.pageEditorData.english.controller.value,
      },
    });
  }
}
